import '../../node_modules/remixicon/fonts/remixicon.css';
import '../css/style.css';

import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();
